export default function Consents(consentElement: { addEventListener: (arg0: string, arg1: () => void) => void }) {
    const consentForm = document.querySelector<HTMLFormElement>('[data-element="consent-form"]')
    const consentCheckBoxes = document.querySelectorAll<HTMLInputElement>('[data-element="consent-checkbox"]')

    consentElement?.addEventListener('click', function () {
        consentCheckBoxes.forEach((checkbox: HTMLInputElement): void => {
            checkbox.checked = false
        })
        consentForm?.submit()
    })
}
